import { useState } from "react";
import { FaPlusCircle, FaMinusCircle } from 'react-icons/fa';


const FAQSection = () => {
  const [openSection, setOpenSection] = useState(null);

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };
  
  return (
    <div className="faq-product-content">
      <div className="faq-loan-content">
        <h5
          className="faq-content-subtitle faq-dropdown-btn"
          onClick={() => toggleSection("aboutFAQ")}
        >
          <span className="faq-icon">
            <span className="faq-highlight">About Right Lender</span>
          </span>
          {openSection === "aboutFAQ" ? <FaMinusCircle /> : <FaPlusCircle />}
        </h5>
        {openSection === "aboutFAQ" && (
          <>
            <div className="faq-product-description">
              <strong className="faq-questions">
                1. Is Right Lender registered with the RBI?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                No — Right Lender is not an RBI-registered lender. We are
                associated with multiple RBI-registered banks and NBFCs to
                connect you with the best offers.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                2. How does Right Lender work?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                Once you apply with Right Lender, our technology shortlists
                the right bank/NBFC for you based on your company, salary,
                age, and pin code. Our experienced team then calls you,
                discusses your profile, and moves your application to the
                right bank/NBFC.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                3. Why should I apply with Right Lender?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                We help you avoid unnecessary rejections by matching you only
                with banks/NBFCs whose policies you meet. This saves time,
                protects your credit score, and increases your approval
                chances.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                4. How does Right Lender approve a loan?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                We don’t approve or reject loans directly. Our expert team
                verifies your documents, checks your company and salary
                details, and matches you with the right bank/NBFC’s offer. The
                final approval is done by the bank/NBFC.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                5. If Right Lender recommends me, can the bank still reject my
                loan?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                Yes — there is still a possibility. While Right Lender
                thoroughly checks your profile, factors like a low credit
                score, recent changes in bank/NBFC policies, or tighter
                lending criteria can lead to rejection.
                <br />
                <span className="faq-questions-icon">●</span>
                However, if one bank/NBFC rejects your application but your
                profile still has potential, we forward it to another suitable
                lender. If the rejection is due to a strong policy reason
                (e.g., very low credit score or disallowed employer), most
                other banks/NBFCs will also reject for the same reason.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                6. Can I pay my EMI or foreclosure amount through Right
                Lender?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                No — we do not collect EMI payments or any kind of
                loan-related payments. All payments must be made directly to
                your bank/NBFC.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                7. Can I close my loan online?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                Yes — you can close your loan through the bank’s official
                website or by visiting the nearest branch. You’ll need to get
                a foreclosure letter from the bank to complete the process.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                8. Does Right Lender charge for its services?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                No — Right Lender is a free platform. You do not need to pay
                us for applying or processing.
              </p>
            </div>
          </>
        )}
      </div>
      <div className="faq-loan-content">
        <h5
          className="faq-content-subtitle faq-dropdown-btn"
          onClick={() => toggleSection("personal")}
        >
          <span className="faq-icon">
            <span className="faq-highlight">Personal Loan</span>
          </span>
          {openSection === "personal" ? <FaMinusCircle /> : <FaPlusCircle />}
        </h5>

        {openSection === "personal" && (
          <>
            <div className="faq-product-description">
              <strong className="faq-questions">
                1. How soon will I get the loan amount?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                Approval can happen within 5 minutes to 48 hours, and
                disbursement is usually within 1–3 working days, provided all
                documents are in order.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                2. What is the minimum and maximum loan amount I can apply
                for?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                You can apply for personal loans starting from ₹1,00,000 up to
                ₹50,00,000 (subject to your eligibility, income, and bank/NBFC
                policies).
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                3. What is the interest rate for personal loans?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                Interest rates generally start from 10.75% p.a. (sometimes
                10.25% p.a. under special offers) and vary depending on your
                credit score, income, employer category, and the lender’s
                real-time policies.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                4. Can I foreclose or prepay my loan early?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                Yes — most lenders allow foreclosure or part-prepayment after
                a lock-in period of 6–12 months. In some cases, even after
                paying the first EMI you can pre-close, but foreclosure
                charges will apply as per the lender’s policy.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                5. Will applying with Right Lender affect my CIBIL score?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                No — when you apply through Right Lender, we match you with
                eligible lenders without multiple hard inquiries, so your
                CIBIL score stays safe.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                6. Can I apply if I already have other loans?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                Yes, as long as your repayment history is good and your
                debt-to-income ratio is within acceptable limits.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                7. Do I need to provide collateral or security?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                No — personal loans are unsecured, so you don’t need to pledge
                property, gold, or other assets.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                8. What is the minimum CIBIL score required?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>A score of 700+
                is generally preferred, but some lenders may still consider
                applicants with lower scores if other eligibility factors are
                strong.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                9. What is the processing fee?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                Processing fees usually start from 2% to 5% of the loan
                amount, depending on the bank/NBFC. Right Lender always helps
                you find the best available offer.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                10. What charges are debited by the bank/NBFC? Are there any
                hidden charges?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                Typically, charges include processing fees + insurance charges
                deducted from the sanctioned loan amount. Right Lender ensures
                complete transparency — no hidden charges.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                11. What is the EMI bounce charge?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                If your EMI fails due to insufficient balance, banks/NBFCs
                usually levy charges between ₹250 to ₹1,500, depending on the
                lender’s policy.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                12. Is there any overdraft (OD) facility in personal loans?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                Yes — some banks/NBFCs offer personal loan OD facilities,
                depending on your profile.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                13. I am a contract employee; can I apply for a loan?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                No — currently, Right Lender does not service personal loans
                for contract employees.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                14. I don’t have a payslip; can I still get a loan?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                Yes — but only for a limited loan amount, and only if you meet
                other policy criteria.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                15. Can I transfer my personal loan to another bank?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                Yes — you can transfer your existing personal loan to another
                bank/NBFC for better interest rates or terms, subject to
                eligibility.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                16. What is the foreclosure charge?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                Some offer 0% foreclosure (special offers). Foreclosure
                charges depend on the lender. Others may levy charges as per
                their policy. You can foreclose if you have surplus funds and
                the lender allows it.
              </p>
            </div>
          </>
        )}
      </div>

      <div className="faq-loan-content">
        <h5
          className="faq-content-subtitle faq-dropdown-btn"
          onClick={() => toggleSection("business")}
        >
          <span className="faq-icon">
            <span className="faq-highlight">Business Loan</span>
          </span>
          {openSection === "business" ? <FaMinusCircle /> : <FaPlusCircle />}
        </h5>

        {openSection === "business" && (
          <>
            <div className="faq-product-description">
              <strong className="faq-questions">
                1. What is the eligibility to apply for a business loan?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                Business loans are available for self-employed individuals,
                traders, manufacturers, service providers, retailers,
                GST-registered businesses, self-employed professionals, and
                doctors.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                2. What is the minimum and maximum loan amount?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                You can apply from ₹3 Lakhs to ₹1 Crore, depending on your
                income, stock value, and bank transactions.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                3. Is owning a house mandatory?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                Most lenders prefer applicants with their own house. Some
                lenders still offer loans without property ownership,
                depending on profile strength.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                4. What is the minimum CIBIL score required?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>A score of 700 or
                above is generally preferred for better approval chances.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                5. I already have an OD — can I convert it into a term loan?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                Yes, you can, subject to eligibility and lender approval.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                6. How do banks decide my business loan offer?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                Lenders evaluate your average bank transactions, stock value,
                and annual turnover to determine loan amount and terms.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                7. Can I make partial payments towards my loan?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                No — partial prepayments aren’t allowed. However, you can
                foreclose the loan after the lock-in period, with applicable
                charges.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                8. I have an OD/CC account — can I transfer it to another
                bank?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                Yes, you can transfer your OD/CC facility to another bank if
                you meet their eligibility criteria.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                9. Is collateral required for a business loan?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                No — standard business loans are completely collateral-free,
                and you don’t need to pledge assets.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                10. For CC/OD facilities, is collateral required?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                It depends — CC/OD can be offered with or without collateral
                based on the lender’s terms.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                11. Will applying through Right Lender affect my CIBIL score?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                No — Right Lender does not pull your CIBIL directly. However,
                the partnered bank/NBFC will check it during the approval
                process.
              </p>
            </div>
          </>
        )}
      </div>

      <div className="faq-loan-content">
        <h5
          className="faq-content-subtitle faq-dropdown-btn"
          onClick={() => toggleSection("home")}
        >
          <span className="faq-icon">
            <span className="faq-highlight">Home Loan</span>
          </span>
          {openSection === "home" ? <FaMinusCircle /> : <FaPlusCircle />}
        </h5>

        {openSection === "home" && (
          <>
            <div className="faq-product-description">
              <strong className="faq-questions">
                1. Things you must know before applying for a Home Loan
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                Buying a home is a major financial milestone, and for most
                first-time buyers, a home loan is essential to make that dream
                a reality. Before applying, you should understand:{" "}
              </p>
              <ul className="faq-bullet-list">
                <li>
                  <span className="faq-highlight">Eligibility:</span> Based on
                  income, age, financial stability, credit score, and
                  repayment capacity.
                </li>
                <li>
                  <span className="faq-highlight">Loan Types:</span> Fixed,
                  floating, and combination rates.
                </li>
                <li>
                  <span className="faq-highlight">Pre-Approval:</span>{" "}
                  Improves negotiation power and speeds up property selection.
                </li>
                <li>
                  <span className="faq-highlight">Co-Applicants:</span> Adding
                  a spouse or parent can boost eligibility.
                </li>
                <li>
                  <span className="faq-highlight">Loan-to-Value Ratio:</span>{" "}
                  Lenders typically fund 75–90% of property value; the rest is
                  your contribution.
                </li>
                <li>
                  <span className="faq-highlight">Costs:</span> Interest
                  rates, processing fees, and prepayment/foreclosure charges.
                </li>
                <li>
                  <span className="faq-highlight">Repayment Options:</span>{" "}
                  EMI or Pre-EMI (for under-construction properties).
                </li>
                <li>
                  <span className="faq-highlight">Tenure:</span> Longer
                  tenures mean lower EMIs but higher overall interest.
                </li>
                <li>
                  <span className="faq-highlight">Documentation:</span>{" "}
                  Includes KYC, income proof, property papers, etc. (stored
                  securely by the lender).
                </li>
              </ul>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                2. How does Right Lender decide my home loan eligibility?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                Your eligibility is primarily based on your{" "}
                <span className="faq-highlight">
                  income and repayment capacity
                </span>
                . Other factors include:
              </p>
              <ul className="faq-bullet-list">
                <li>Age, qualification, number of dependents</li>
                <li>Spouse’s income (if applicable)</li>
                <li>Assets & liabilities, savings history</li>
                <li>Stability & continuity of occupation</li>
              </ul>
            </div>

            <div className="faq-product-description">
              <p>
                <strong className="faq-questions">
                  3. What types of home loans are available?
                </strong>
                <br />
              </p>
              <ul className="faq-bullet-list">
                <li>Home construction loan</li>
                <li>Home purchase loan (new/resale)</li>
                <li>Home renovation loan</li>
                <li>Top-up loan on existing home loan</li>
                <li>Residential & commercial property loans</li>
              </ul>
            </div>

            <div className="faq-product-description">
              <p>
                <strong className="faq-questions">
                  4. What is the procedure to apply for a home loan?
                </strong>
              </p>
              <ul className="faq-bullet-list">
                <li>
                  Fill application via Right Lender and upload documents.
                </li>
                <li>
                  Our team calls you, evaluates your profile, and recommends a
                  bank/NBFC.
                </li>
                <li>Prepare xerox copies of all documents.</li>
                <li>
                  Bank/NBFC staff visits, collects documents, answers queries.
                </li>
                <li>Lender verifies and processes your application.</li>
              </ul>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">5. What is Pre-EMI?</strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                Under Pre-EMI, you pay only interest on the disbursed loan
                amount until possession. Full EMI starts after possession.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                6. How do banks value the property for insurance purposes?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                Banks usually calculate by multiplying built-up area ×
                construction cost per sq. ft.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                7. Can I apply jointly with my spouse? Will both our salaries
                be considered?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                Yes, if the property is jointly owned or spouse is guarantor.
                Both incomes boost eligibility and sanction.
              </p>
              <ul className="faq-bullet-list">
                <li>The property is jointly owned, or</li>
                <li>The spouse stands as a guarantor.</li>
              </ul>
              <p>This helps increase loan eligibility and sanction amount.</p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                8. When will my home loan interest rate change?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                If linked to EBLR (External Benchmark Lending Rate), the bank
                resets rates periodically as per RBI/bank guidelines.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                9. Can I transfer my home loan to another lender?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                Yes, through balance transfer if another lender offers lower
                rates or longer tenure — reduces EMI & interest cost.
              </p>
              <ul className="faq-bullet-list">
                <li>Lower interest rate</li>
                <li>
                  Longer tenure <br />
                  This can help reduce your EMI burden and overall interest
                  cost.
                </li>
              </ul>
            </div>

            <div className="faq-product-description">
              <p>
                <strong className="faq-questions">
                  10. What is the maximum home loan amount I can get?
                </strong>
                <br />
              </p>
              <ul className="faq-bullet-list">
                <li>Minimum: ₹10 Lakhs</li>
                <li>
                  Maximum: Up to ₹10 Crores
                  <br />
                  The exact amount depends on income, age, repayment capacity,
                  and lender policy.
                </li>
              </ul>
            </div>
          </>
        )}
      </div>

      <div className="faq-loan-content">
        <h5
          className="faq-content-subtitle faq-dropdown-btn"
          onClick={() => toggleSection("mortgage")}
        >
          <span className="faq-icon">
            <span className="faq-highlight">LAP or Mortgage Loan</span>
          </span>
          {openSection === "mortgage" ? <FaMinusCircle /> : <FaPlusCircle />}
        </h5>

        {openSection === "mortgage" && (
          <>
            <div className="faq-product-description">
              <strong className="faq-questions">
                1. What should I do before applying for a mortgage loan, and
                how does it work?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                Mortgage loans can feel lengthy, but with preparation the
                process is stress-free. Before applying:
              </p>
              <ul className="faq-bullet-list">
                <li>
                  Ensure all property legal documents are proper and valid.
                </li>
                <li>
                  Lenders will conduct multiple checks — legal clearance,
                  property valuation, your income, credit score, and
                  residence/office verification (for both salaried and
                  self-employed applicants).
                </li>
                <li>
                  Once approved, the property is registered with a Memorandum
                  of Deposit (MOD) in favor of the lender.
                </li>
                <li>
                  The entire process usually takes 3 to 10 working days,
                  depending on lender policies and the completeness of your
                  documents.
                </li>
              </ul>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                2. What type of property is eligible?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                Both self-occupied residential and commercial properties are
                accepted, subject to lender policies.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                3. Can I get an Overdraft (OD) facility against my property?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                Yes — many banks/NBFCs offer OD facilities against property,
                depending on your profile and eligibility.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                4. Can I get a top-up loan on my existing LAP?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                Yes — if your income supports repayment and the property value
                allows, you may be eligible for a top-up loan with a longer
                tenure and better benefits.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                5. Do I need to pay any upfront processing charges?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                Yes — lenders usually charge a processing fee of around 1%
                (may vary by lender). Note: Right Lender never collects any
                fee directly. Fees are paid only to the bank/NBFC branch. Do
                not pay any individual or third party.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                6. How do I track my loan details?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                You can track your loan through your lender’s official website
                or by downloading the respective bank/NBFC mobile app.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                7. When will I get my original property documents back after
                closing or foreclosing the loan?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                Once you clear the outstanding loan amount, lenders typically
                return your original property documents within 15 working
                days, subject to their internal policies.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                8. What is the current interest rate for mortgage loans?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                Rates usually start from 9.50% p.a. and vary based on your
                profile, property type, and lender’s real-time offers.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                9. Can I make partial prepayments or foreclose my mortgage
                loan?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                Yes — most lenders allow it, though some may charge
                foreclosure/prepayment fees depending on the loan type and
                borrower category.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                10. What is the normal time required for disbursement of a
                Mortgage Loan?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="ourservice-icon-green">●</span> It usually
                takes 3 to 7 working days to get a mortgage loan sanctioned,
                provided all required documents are submitted and cleared.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                11. Can I pledge agricultural land for LAP?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="ourservice-icon-green">●</span> No —
                agricultural property cannot be pledged for a Loan Against
                Property.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                12. Can I add my spouse’s/parents’ income for a Loan Against
                Property (LAP)?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="ourservice-icon-green">●</span> Yes — you can
                add your spouse’s or parents’ income when applying for a LAP,
                provided they are taken as co-applicants/co-owners of the
                property. This helps increase your loan eligibility and may
                get you a higher sanction amount.
              </p>
            </div>
          </>
        )}
      </div>

      <div className="faq-loan-content">
        <h5
          className="faq-content-subtitle faq-dropdown-btn"
          onClick={() => toggleSection("nri")}
        >
          <span className="faq-icon">
            <span className="faq-highlight">NRI Loans</span>
          </span>
          {openSection === "nri" ? <FaMinusCircle /> : <FaPlusCircle />}
        </h5>

        {openSection === "nri" && (
          <>
            <div className="faq-product-description">
              <p className="faq-product-para">
                <strong className="faq-questions">
                  1. What types of loans can NRIs apply for in India?
                </strong>
                <br />
              </p>
              <ul className="faq-bullet-list">
                <li>Home Loans (purchase/construction of property)</li>
                <li>Personal Loans (for personal needs)</li>
                <li>
                  Loan Against Property (LAP) – mortgaging
                  residential/commercial property in India
                </li>
              </ul>
            </div>

            <div className="faq-product-description">
              <p className="faq-product-para">
                <strong className="faq-questions">
                  2. What is the maximum personal loan amount I can get as an
                  NRI?
                </strong>
                <br />
              </p>
              <ul className="faq-bullet-list">
                <li>
                  You can get up to{" "}
                  <span className="faq-highlight">₹15 lakhs</span> (approx.)
                  depending on your income, credit score, and employer
                  profile.
                </li>
                <li>
                  Interest rates usually start around{" "}
                  <span className="faq-highlight">12% p.a.</span> with a
                  tenure of up to 3 years (may vary by lender).
                </li>
              </ul>
            </div>

            <div className="faq-product-description">
              <p className="faq-product-para">
                <strong className="faq-questions">
                  3. How much home loan can I get as an NRI?
                </strong>
                <br />
              </p>
              <ul className="faq-bullet-list">
                <li>There is no fixed maximum limit.</li>
                <li>
                  The eligible amount depends on your income, salary credits,
                  age, repayment capacity, and property value.
                </li>
              </ul>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                4. I am an NRI. Can I get a home loan in India? Do I need to
                visit India?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span> Yes, NRIs are
                eligible for home loans in India.
              </p>
              <p className="faq-product-paragraph">
                <span className="faq-questions-icon">●</span> While you can
                apply from abroad, physical presence is highly recommended
                for:
              </p>
              <ul className="faq-bullet-list">
                <li>Property registration</li>
                <li>Signing loan documents</li>
                <li>Completing KYC formalities</li>
              </ul>
              <p className="faq-product-para">
                (Some banks may allow Power of Attorney, but presence is
                generally preferred.)
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                5. As an NRI, can I get a Loan Against Property (LAP) in
                India?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span> Yes, NRIs are
                eligible for Loan Against Property, subject to:
              </p>
              <ul className="faq-bullet-list">
                <li>Proper documentation</li>
                <li>A valid property in India</li>
                <li>Meeting lender’s eligibility criteria</li>
              </ul>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                6. Do I need a co-applicant for a personal loan?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span> Yes, usually a
                close relative in India (such as spouse or parent) is required
                as a co-applicant or guarantor for personal loans.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                7. My spouse and I are both NRIs living abroad. Can we still
                get a home loan?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span> Yes, both your
                incomes can be considered for higher eligibility.
              </p>
              <p className="faq-product-paragraph">
                <span className="faq-questions-icon">●</span> However, at
                least one applicant/co-applicant must be present in India at
                the time of:
              </p>
              <ul className="faq-bullet-list">
                <li>Document signing</li>
                <li>
                  Property registration (Power of Attorney can sometimes be
                  used, depending on bank policy.)
                </li>
              </ul>
            </div>
          </>
        )}
      </div>

      <div className="faq-loan-content">
        <h5
          className="faq-content-subtitle faq-dropdown-btn"
          onClick={() => toggleSection("doctor")}
        >
          <span className="faq-icon">
            <span className="faq-highlight">Doctor Loan</span>
          </span>
          {openSection === "doctor" ? <FaMinusCircle /> : <FaPlusCircle />}
        </h5>

        {openSection === "doctor" && (
          <>
            <div className="faq-product-description">
              <strong className="faq-questions">
                1. What is a Doctor Loan?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>A Doctor Loan is
                a customized loan offered exclusively to medical professionals
                like MBBS, BDS, MD, MS, and other recognized practitioners for
                personal or professional purposes.
              </p>
            </div>

            <div className="faq-product-description">
              <p className="faq-product-para">
                <strong className="faq-questions">
                  2. What can a Doctor Loan be used for?
                </strong>
              </p>
              <ul className="faq-bullet-list">
                <li>Setting up or expanding a clinic/hospital</li>
                <li>Purchasing medical equipment</li>
                <li>Funding higher education or specialization</li>
                <li>Working capital for professional needs</li>
                <li>Personal requirements (travel, wedding, etc.)</li>
              </ul>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                3. Who is eligible for a Doctor Loan?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                Medical professionals with recognized qualifications such as{" "}
                <span className="faq-highlight">
                  MBBS, BDS, BAMS, BHMS, MD, MS
                </span>
                , and practicing doctors registered with Medical Council of
                India or respective State Councils are eligible.
              </p>
            </div>

            <div className="faq-product-description">
              <p className="faq-product-para">
                <strong className="faq-questions">
                  4. What is the maximum loan amount available under Doctor
                  Loan?
                </strong>
              </p>
              <ul className="faq-bullet-list">
                <li>
                  Personal Loan for Doctors: Up to ₹40 Lakhs (unsecured)
                </li>
                <li>
                  Professional / Business Loan: Up to ₹2 Crores (secured)
                </li>
              </ul>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                5. Do I need collateral to avail a Doctor Loan?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                No collateral is required for unsecured doctor loans. For
                higher loan amounts, lenders may ask for property or other
                security.
              </p>
            </div>

            <div className="faq-product-description">
              <p className="faq-product-para">
                <strong className="faq-questions">
                  6. What documents are required for a Doctor Loan?
                </strong>
              </p>
              <ul className="faq-bullet-list">
                <li>KYC documents (ID & Address proof)</li>
                <li>Medical registration certificate</li>
                <li>Income proof (IT returns, salary slips, etc.)</li>
                <li>Bank statements (last 6 months)</li>
                <li>Clinic/hospital ownership proof (if applicable)</li>
              </ul>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                7. What is the repayment tenure for Doctor Loans?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                Repayment tenure usually ranges from{" "}
                <span className="faq-highlight">12 months to 84 months</span>,
                depending on the type of loan and lender policy.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                8. Can I get a top-up on my existing Doctor Loan?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                Yes, if you have a good repayment track record, lenders may
                offer a top-up loan on your existing doctor loan for
                additional funding.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                9. How fast can I get approval for a Doctor Loan?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                Many banks and NBFCs offer{" "}
                <span className="faq-highlight">
                  instant approval and quick disbursal
                </span>{" "}
                (within 48–72 hours) if documentation is complete.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                10. Can I apply jointly with another doctor or spouse?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>
                Yes, co-applicants like spouse or professional partners can be
                added to enhance loan eligibility and sanction amount.
              </p>
            </div>
          </>
        )}
      </div>

      <div className="faq-loan-content">
        <h5
          className="faq-content-subtitle faq-dropdown-btn"
          onClick={() => toggleSection("balance")}
        >
          <span className="faq-icon">
            <span className="faq-highlight">Balance Transfer</span>
          </span>
          {openSection === "balance" ? <FaMinusCircle /> : <FaPlusCircle />}
        </h5>

        {openSection === "balance" && (
          <>
            <div className="faq-product-description">
              <strong className="faq-questions">
                1. Why is Balance Transfer important?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span>A balance
                transfer is a smart way to reduce your interest burden. If you
                originally took a loan at a high interest rate, you don’t need
                to continue paying that high rate for the entire tenure. By
                transferring your loan to another bank/NBFC offering a lower
                rate, you can save significantly — provided you have good
                repayment history, income eligibility, and a clear credit
                track record.
              </p>
            </div>

            <div className="faq-product-description">
              <p className="faq-product-para">
                <strong className="faq-questions">
                  2. Which loans can I transfer?
                </strong>
              </p>
              <ul className="faq-bullet-list">
                <li>Home Loan (most common)</li>
                <li>Mortgage Loan (LAP)</li>
                <li>Business Loan / Overdraft (OD) / Cash Credit (CC)</li>
                <li>Collateral-based Loans</li>
                <li>Personal Loan (if current interest rate is high)</li>
                <li>
                  Credit Card Outstanding (as balance transfer to another
                  card/lender)
                </li>
              </ul>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                3. What are the benefits of a Balance Transfer?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span> The primary
                benefit is interest savings. Here’s an approximate calculation
                (values may vary based on lender policies):
              </p>
              <ul className="faq-bullet-list">
                <li>
                  Home Loan of ₹10,00,000 for 20 years at 14% → EMI = ₹12,435
                </li>
                <li>Total Interest = ₹19,84,000</li>
                <li>Total Outgo = ₹29,84,450</li>
                <li>Transferred to 20 years at 8.5% → EMI = ₹8,678</li>
                <li>Total Interest = ₹10,82,776</li>
                <li>Total Outgo = ₹20,82,776</li>
              </ul>
              <p className="faq-product-para">
                Note: Always compare your current loan terms with the new
                offer (interest rate, EMI, processing fees, tenure) to check
                actual savings.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                4. Should I transfer if I already have the lowest rate? When
                is the right time to transfer?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span> If your current
                interest rate is already low, a transfer is unnecessary.
                <br />
                <span className="faq-questions-icon">●</span> Before
                transferring, calculate the new EMI, processing fees,
                remaining tenure, and total savings.
                <br />
                <span className="faq-questions-icon">●</span> The best time to
                transfer is after 1–2 years of repayment when you are eligible
                for lower interest.
                <br />
                <span className="faq-questions-icon">●</span> If your loan is
                near closure (less than 12 months left), transferring is
                usually not worth it.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                5. Can I transfer my credit cards?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span> Yes, you can
                transfer your existing credit card outstanding balance to
                another card/bank that offers a lower interest rate.
              </p>
            </div>

            <div className="faq-product-description">
              <strong className="faq-questions">
                6. Is CIBIL score important for a Balance Transfer?
              </strong>
              <br />
              <p className="faq-product-para">
                <span className="faq-questions-icon">●</span> Absolutely. A
                good CIBIL score (usually 700+) is mandatory to qualify for a
                balance transfer. Lenders assess your repayment track record
                and creditworthiness before approving the transfer.
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default FAQSection;
